import { render, staticRenderFns } from "./BusinessUnit.vue?vue&type=template&id=1a3fafc2&scoped=true"
import script from "./BusinessUnit.vue?vue&type=script&lang=js"
export * from "./BusinessUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3fafc2",
  null
  
)

export default component.exports